import React, { useState, useRef, useEffect } from "react";

export default function DropDownEditableEnum({
  value,
  onChange,
  options = [],
  placeholder = "",
  style = {}
}) {

  const [open, setOpen] = useState(false);
  const [inputValue, setInputValue] = useState(value ?? "");
  const [highlightIndex, setHighlightIndex] = useState(-1);

  const containerRef = useRef(null);
  const inputRef = useRef(null);

  useEffect(() => {
    setInputValue(value ?? "");
  }, [value]);

  // close when clicking outside
  useEffect(() => {
    function handleClickOutside(e) {
      if (!containerRef.current?.contains(e.target)) {
        setOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const filtered = options.filter(o =>
    !inputValue ||
    o.id?.toLowerCase().includes(inputValue.toLowerCase()) ||
    o.zh?.toLowerCase().includes(inputValue.toLowerCase())
  );

  function selectItem(item) {
    const v = item.zh ? `${item.zh} ${item.id}` : item.id;

    setInputValue(v);
    onChange && onChange(v);
    setOpen(false);
  }

  function handleKeyDown(e) {

    if (!open && (e.key === "ArrowDown" || e.key === "ArrowUp")) {
      setOpen(true);
      return;
    }

    if (!open) return;

    if (e.key === "ArrowDown") {
      e.preventDefault();
      setHighlightIndex(i => Math.min(i + 1, filtered.length - 1));
    }

    if (e.key === "ArrowUp") {
      e.preventDefault();
      setHighlightIndex(i => Math.max(i - 1, 0));
    }

    if (e.key === "Enter") {
      if (highlightIndex >= 0 && filtered[highlightIndex]) {
        selectItem(filtered[highlightIndex]);
      }
    }

    if (e.key === "Escape") {
      setOpen(false);
    }
  }
  //console.log("filtered.length: ", filtered.length)
  return (
    <div
      ref={containerRef}
      style={{
        position: "relative",
        width: "100%",
        ...style
      }}
    >
      <input
        ref={inputRef}
        value={inputValue ?? ""}
        placeholder={placeholder}
        onFocus={() => setOpen(true)}
        onChange={(e) => {
          const v = e.target.value;
          //console.log("value", v)
          setInputValue(v);
          onChange && onChange(v);
          setOpen(true);
        }}
        onKeyDown={handleKeyDown}
        style={{
          width: "100%",
          padding: "0.45rem 0.6rem",
          fontSize: "0.95rem",
          borderRadius: "0.375rem",
          border: "1px solid #ccc",
          boxSizing: "border-box"
        }}
      />

      {open && filtered.length > 0 && (
        <div
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            right: 0,
            background: "#fff",
            border: "1px solid #ddd",
            borderTop: "none",
            maxHeight: "12rem",
            overflowY: "auto",
            zIndex: 50
          }}
        >
          {filtered.map((o, i) => (
            <div
              key={i}
              onMouseDown={() => selectItem(o)}
              style={{
                padding: "0.45rem 0.6rem",
                cursor: "pointer",
                fontSize: "0.9rem",
                background: i === highlightIndex ? "#eef4ff" : "#fff"
              }}
            >
            {o.zh ? (
                <>
                  <span>{o.zh}</span>
                  <span style={{ marginLeft: "0.5rem", color: "#888", fontSize: "0.8rem" }}>
                    {o.id}
                  </span>
                </>
              ) : (
                o.id
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}